import { useState } from 'react';
import { useMutation } from 'react-query';
import { BiPlus, BiTrash } from 'react-icons/bi';

import { QuestionsCategory } from 'api/questions/types';

import { QuestionCategoryFormModal } from 'components/shared/forms/QuestionCategoryFormModal';
import { QuestionCategoriesTable } from 'components/shared/tables/QuestionCategoriesTable';
import { deleteQuesionCategories, fetchQuestionsCategories } from 'api/questions';
import { SearchField } from 'components/ui/SearchField';
import { useSortedData } from 'hooks/useSortedData';
import { useAuthStore } from 'store/auth';

export const QuestionCategories = () => {
  const { user } = useAuthStore();
  const [itemForUpdate, setItemForUpdate] = useState<QuestionsCategory | null>(null);

  const [selected, setSelected] = useState<string[]>([]);
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);

  const { mutate } = useMutation(deleteQuesionCategories);

  const { search, isLoading, searchedData, refetch, sort } = useSortedData({
    queryFn: fetchQuestionsCategories,
    searchKeys: ['name'],
    queryKey: 'question-categories'
  });

  const onDelete = (ids: string[]) => {
    mutate(ids, {
      onSuccess: () => {
        refetch();
        if (selected.length) setSelected([]);
      }
    });
  };

  return (
    <div>
      <div className="fixed top-0 left-0 right-0 lg:static flex items-center justify-between gap-3 p-3 lg:p-5 bg-white z-50 shadow-card lg:shadow-none">
        <SearchField {...search} />
        <div className="flex items-center gap-6">
          {selected.length ? (
            <button className="iconBtn danger" onClick={() => onDelete(selected)}>
              <BiTrash />
            </button>
          ) : null}
          {(user?.userRole === 'admin' || user?.userRole === 'moderator') && (
            <button className="secondaryBtn !capitalize" onClick={() => setIsOpenCreateModal(true)}>
              <BiPlus />
              New category
            </button>
          )}
        </div>
      </div>
      <div className="p-5">
        <QuestionCategoriesTable
          sort={sort}
          isLoading={isLoading}
          data={searchedData}
          onUpdate={(item) => setItemForUpdate(item)}
          onDelete={(id) => onDelete(id)}
          selected={selected}
          setSelected={setSelected}
        />
      </div>

      {(isOpenCreateModal || itemForUpdate) && (
        <QuestionCategoryFormModal
          questionCategory={itemForUpdate}
          refetch={refetch}
          onClose={() => {
            setIsOpenCreateModal(false);
            setItemForUpdate(null);
          }}
        />
      )}
    </div>
  );
};
